$(document).ready(function(){
	hideShowMore();
	checkoutBasket();
	initPagination();
	
	$('.filters .filters-group ul li a').click(hideShowMore());
    function hideShowMore()
    {
    	var litNext = $('.load-more');
    	$('.filter-selected').length>=1 ? litNext.hide() : litNext.show();
    }
    $('.basket a').on('click', function(){
    	document.literatureForm.submit();
    });
	$(".basket-literature-item .add-container .icon-minus").on('click', function(){
		var $item = $(this).closest('.basket-literature-item');
		$.ajax({    			
			type: 'GET',
			url:  $("#removeSelectedLiteratureUrl").val() + "?action=removeSelection" + "&id=" + $(this).parent().parent().data("value"),
			success: function(data) {
				$item.remove();
				$("#order-count").text($(".basket-literature-item").length);
			}
		});
	});
    function initPagination(){
        $('.load-more-button').on('click', function(e){
        	var $showMoreButton = $(this);
    		e.preventDefault();
    		
        	var loadMoreWrapper = $showMoreButton.closest('.load-more')
        	loadMoreWrapper.remove();
        	paginate($showMoreButton);
        })
    }
    function paginate($showMoreButton) {
    	$.ajax({
		     type: 'GET',
		     url: $showMoreButton.attr("href"),
		     success: function(data) {
		    	 var itemsToAdd = $(data).find('#literature-first').html();
		    	 $("#literature-first").append(itemsToAdd);
		    	 
		    	 var incomingItems = $(data).find('.literature-item').length;
		    	 var initalPageSize = $("#literature-first").data("page-size");
		    	 if( incomingItems < initalPageSize ){
		    		 $('.load-more').hide();
		    	 } else {
			    	 initPagination();
		    	 }
		    	 checkoutBasket();
		     }
		});	
    }
    function checkoutBasket()
    {
    	$(".literature-item .add-container span").off('click').on('click', function(e){
    		e.preventDefault();
    		var span = $(this);
    		var pageUrl = $("#updateSelectedLiteratureUrl").val();
    		var action = "?action=updateSelection";
    		var action2 = $(this).hasClass('icon-add') ? "true" : "false";
    		pageUrl = pageUrl + action + "&save="+action2+"&id=" + $(this).parent().parent().data("value");    			
    		var request = $.ajax({
    			url: pageUrl,
    			type: 'GET',
    			dataType: 'text',
    			success: function(result) {    					
    				$(".basket .total").text(result);
    				span.toggleClass('icon-add icon-minus active');
    			}    						
    		});
    	});
    } 	
});


